import { alpha, darken, lighten, maxHeight } from "@mui/system";

const styles = (theme) => ({
  container: { display: "flex", flexDirection: "column", gap: 0 },
  content: { display: "flex", flexDirection: "column", gap: 1 },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexGrow: 1,
    gap: 2,
    "@media (max-width: 400px)": {
      flexDirection: "column",
    },
  },
  filterBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  formControl: {
    display: "flex",
    width: "130px",
    minWidth: "130px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "primary",
      color: "primary",
    },
    "& .MuiInputLabel-root": {
      color: "primary",
    },
    svg: {
      color: "primary",
    },
    input: {
      color: "primary",
    },
  },
  paperClientes: {
    width: "100%",
    height: "500px",
    overflow: "hidden",
    borderRadius: "10px",
    position: "relative",
  },
  paperRecurringAlerts: {
    width: "100%",
    height: "400px",
    borderRadius: "10px",
    position: "relative",
  },
  gridTitle: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    textAlign: "left",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  textFieldSearch: {
    width: "100%",
    maxWidth: 500,
    display: "flex",
    flexGrow: 1,
    fontSize: "0.90rem", // diminui fonte geral
  },
  launchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "100%",
  },
  launchIcon: { cursor: "pointer", height: "19px", width: "19px" },
  containerDataGrid: { display: "flex", height: "345px" },
  containerHeaderRecurringAlerts: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    p: "10px 20px",
    "@media (max-width: 560px)": {
      flexDirection: "column",
      gap: 1,
      alignItems: "flex-start",
    },
  },
  boxRecurringAlertsSearchePrintFields: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    alignItems: "center",
  },
  recurringAlertSearchField: {
    maxWidth: "242px",
  },
  recurringAlertPrintIcon: {
    color: theme.palette.primary.main,
  },
  tab: {
    mt: 1.5,
    minHeight: 28,
    maxHeight: 26,
    px: 3,
    mr: 0.4,
    fontSize: "0.875rem",
    fontWeight: 500,
    textTransform: "none",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    minWidth: "80px",
    width: "auto",
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
  },
  containerChips: {
    display: "flex",
    flexDirection: "row",
    gap: 4,
    flexWrap: "nowrap",
    "@media (max-width: 500px)": {
      gap: 1,
    },
  },
  customTooltip: {
    width: "14px",
    height: "14px",
    borderRadius: "2px",
  },
  boxTooltip: {
    bgcolor: theme.palette.paletteCharts.lineCharts,
    padding: "8px",
    borderRadius: "8px",
  },
  tabs: {
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      borderRadius: "5px 5px 0 0",
      p: 0.2,
      mb: 0.5,
    },
    "& button": {
      textTransform: "none",
    },
    borderBottom: 1,
    borderColor: "divider",
    width: "100%",
    "& .MuiTabs-flexContainer": {
      gap: 0.5,
    },
  },
  stylesChips: {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    fontWeight: "bold",
    height: "16px",
    minWidth: "16px",
    width: "auto",

    // Garante que o próprio Chip centralize seu conteúdo
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "&.MuiChip-root": {
      borderRadius: 1,
    },

    // Ajustes na classe interna do label
    "& .MuiChip-label": {
      padding: "0 4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      lineHeight: 1,
      overflow: "visible",
    },
  },
  boxTabs: {
    p: 0,
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
    width: "100%",
    justifyContent: "space-between",
  },
});

export default styles;
